import { Component, computed, input, Signal } from '@angular/core';
import { EzBaseComponent } from "../../components/ez-base.component";
import { MarkdownModule } from "ngx-markdown";
import { DocClassEntry } from "../../types/component-docs.model";
import { resolveShowcaseLinkTokens } from "../showcase-link-tokens";

/**
 * This is the Overview tab in the showcase for a single class
 */
@Component({
    selector: 'ui-showcase-overview, ez-showcase-overview',
    imports: [MarkdownModule],
    templateUrl: './showcase-overview.component.html',
    styleUrl: './showcase-overview.component.scss',
    host: { 'class': "h-full" }
    //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowcaseOverviewComponent extends EzBaseComponent
{

    selectedDoc = input<Signal<DocClassEntry | undefined> | DocClassEntry | undefined>(undefined);
    doc = computed(() => {
      const value = this.selectedDoc();
      return typeof value === "function" ? value() : value;
    });
    readonly descriptionMd = computed(() => resolveShowcaseLinkTokens(this.doc()?.descriptionMd, this.doc()?.libName));

    name = input<string>("");

    /** Routes internal markdown links through Angular Router to avoid full page reloads. */
    protected onMarkdownLinkClick(event: MouseEvent): void {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const target = event.target as HTMLElement | null;
      const anchor = target?.closest('a');
      const href = anchor?.getAttribute('href');
      if (!href || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) {
        return;
      }

      const resolvedUrl = new URL(href, window.location.origin);
      if (resolvedUrl.origin !== window.location.origin) {
        return;
      }

      const normalizedBaseHref = this.baseHref.endsWith('/') ? this.baseHref.slice(0, -1) : this.baseHref;
      let appPath = resolvedUrl.pathname;
      if (normalizedBaseHref && normalizedBaseHref !== '/' && appPath.startsWith(`${normalizedBaseHref}/`)) {
        appPath = appPath.slice(normalizedBaseHref.length);
      }

      event.preventDefault();
      void this.router.navigateByUrl(`${appPath}${resolvedUrl.search}${resolvedUrl.hash}`);
    }
}
